import React, { useState } from "react";
import "./accessories.css";

function Accessories() {
  const accessories = [
    { id: 1, image: "/Renu multi-purpose solution 60ml    1000.jpg", name: "ReRenu multi-purpose solution 60ml", price: 1000, brand: "Renu", size: "60ml" },
    { id: 2, image: "/Bio true - Multi Purpose solution 60ml     1100.jpg", name: "Bio true - Multi Purpose solution 60ml", price: 1100, brand: "Bio True", size: "60ml" },
    { id: 3, image: "/Renu multi-purpose solution 120ml    13000.jpg", name: "Renu multi-purpose solution 120ml", price: 1300, brand: "Renu", size: "120ml" },
    { id: 4, image: "/Bio True - Multi Purpose solution 120ml       2500.jpg", name: "Bio True - Multi Purpose solution 120ml", price: 2500, brand: "Bio True", size: "120ml" },
    { id: 5, image: "/Boston Simplus - Multi Purpose solution 120ml    2200.jpg", name: "Boston Simplus - Multi Purpose solution 120ml", price: 2200, brand: "Boston Simplus", size: "120ml" },
    { id: 6, image: "/Renu Multi-purpose solution 355ml      2200.jpg", name: "Renu Multi-purpose solution 355ml      ", price: 2200, brand: "Renu", size: "355ml" },
    { id: 7, image: "/Bio true - Multi Purpose solution 300ml     2500.jpg", name: "Bio true - Multi Purpose solution 300ml", price: 2500, brand: "Bio True", size: "300ml" },
  ];

  const otherAccessories = [
    { id: 8, image: "/Polarized Clip-on Night Vision    1500.jpg", name: "Polarized Clip-on Night Vision", price: 1500, brand: "Polarized", size: "Standard" },
    { id: 9, image: "/Polarized Clip-on Black      1500.jpg", name: "Polarized Clip-on Black", price: 1500, brand: "Polarized", size: "Standard" },
    { id: 10, image: "/microfiber.jpg", name: "Microfiber Cleaning Cloth", price: 200, brand: "LensPro", size: "Medium" },
    { id: 20, name: "Safety Goggles - Black and Yellow", image: "/img/Safetyimg6.jpg", price:  6000},
  ];

  const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);
  const [sortedAccessories, setSortedAccessories] = useState(accessories);

  const handleAddToCart = (product) => {
    const existingProduct = cart.find(item => item.id === product.id);
    if (existingProduct) {
      const updatedCart = cart.map(item => 
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const newCart = [...cart, { ...product, quantity: 1 }];
      setCart(newCart);
      localStorage.setItem("cart", JSON.stringify(newCart));
    }
    
    // Show alert when product is added
    alert("Product has been added to the cart!");
  };

  const handleSortChange = (event) => {
    const sortBy = event.target.value;
    const sortedArray = [...accessories].sort((a, b) => {
      if (sortBy === "price") {
        return a.price - b.price; // Sort by price
      }
      if (sortBy === "name") {
        return a.name.localeCompare(b.name); // Sort by name alphabetically
      }
      if (sortBy === "brand") {
        return a.brand.localeCompare(b.brand); // Sort by brand alphabetically
      }
      if (sortBy === "size") {
        return a.size.localeCompare(b.size); // Sort by size alphabetically
      }
      return 0; // Default case if no match
    });
    setSortedAccessories(sortedArray);
  };

  return (
    <div className="accessories-container">
      <h1>Accessories</h1>

      <h2 className="maccessories">Main Accessories</h2>
      <div className="controls">
        <div className="sort-dropdown">
          <label htmlFor="sort">Sort By:</label>
          <select id="sort" onChange={handleSortChange}>
            <option value="name">Name</option>
            <option value="price">Price</option>
            <option value="brand">Brand</option>
            <option value="size">Size</option>
          </select>
        </div>
      </div>

      <div className="items-container">
        {sortedAccessories.map((item) => (
          <div key={item.id} className="item-card">
            <img src={item.image || ""} alt={item.name} className="item-image" />
            <h2 className="item-name">{item.name}</h2>
            <p className="item-price">Rs. {item.price.toLocaleString()}</p>
            <button className="add-to-cart" onClick={() => handleAddToCart(item)}>Add to Cart</button>
          </div>
        ))}
      </div>

      <h2 className="oaccessories">Other Accessories</h2>
      <div className="items-container">
        {otherAccessories.map((item) => (
          <div key={item.id} className="item-card">
            <img src={item.image || ""} alt={item.name} className="item-image" />
            <h2 className="item-name">{item.name}</h2>
            <p className="item-price">Rs. {item.price.toLocaleString()}</p>
            <button className="add-to-cart" onClick={() => handleAddToCart(item)}>Add to Cart</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Accessories;
